export default "__VITE_ASSET__a042b48a__"